import { gql } from 'apollo-boost'

export const DECLINE_VISITATION_TO_CONSTRUCTION = gql`
  mutation declineVisitationToConstruction($id: String!) {
    declineSubscriptionSorted(id: $id) {
      message
    }
  }
`
